import request from '@/utils/request'

export function applyAfterSales (params) {
  return request({
    url: process.env.WEB_API + '/afterSales/apply',
    method: 'post',
    data: params
  })
}

/**
 * 获取用户的延赛、退赛申请
 * @param params
 */
export function getAfterSalesList(params) {
  return request({
    url: process.env.WEB_API + '/afterSales/getList',
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/afterSales.js